import {ASSETS_ROOT} from './../../../../../@polygonjs/polygonjs/src/core/loader/AssetsUtils';
import type {ExampleData, DataCallbackOptions} from '../../Common';
import {addPerspectiveCameraOBJWithOrbitControls} from '../../ExampleUtils';

export function createData(options: DataCallbackOptions): ExampleData {
	const {scene} = options;
	const root = scene.root();
	const geo = root.createNode('geo');
	const file = geo.createNode('fileOBJ');
	file.p.url.set(`${ASSETS_ROOT}/models/wolf.obj`);

	// add a light
	root.createNode('hemisphereLight');

	const {perspectiveCamera1} = addPerspectiveCameraOBJWithOrbitControls(root);

	return {
		scene,
		cameraPath: perspectiveCamera1.path(),
		focusedNodes: [file],
		autoLayout: true,
	};
}
// export const sopFile = [
// 	new Example({
// 		name: `${ExamplePrefix.BY_NODE}/sop/file`,
// 		createData,
// 		relatedNodes: [FileOBJSopNode],
// 		categories: [ExampleCategory.ASSETS],
// 		label: 'OBJ',
// 	}),
// ];
